import React, { useRef, useEffect, useState } from "react";
import "../Styles/Travelers_fav_hotel.css";
import api from "../Api";
import hotel_img from "../Images/hotelimg.jpg"
import { useNavigate } from "react-router-dom";

const PropertyCarousel = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [hotelData, setHotelData] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        const fetchHotels = async () => {
            try {
                const res = await api.get("/hotels");
                if (res.data.status === true) {
                    console.log("Fetched hotels:", res.data.data);
                    setHotelData(res.data.data || []);
                    //   setFilteredItems(res.data.data || []);
                }
            } catch (err) {
                console.error("Error fetching hotels:", err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchHotels();
    }, []);
    const scrollRef = useRef(null);

    // Calculate scroll amount per click
    const handleScroll = (direction) => {
        const container = scrollRef.current;

        const card = container.querySelector(".property-card");
        const cardWidth = card ? card.offsetWidth + 20 : 300;

        const isLargeScreen = window.innerWidth >= 1024;
        const scrollAmount = isLargeScreen ? cardWidth * 4 : cardWidth * 1;

        if (direction === "right") {
            container.scrollTo({
                left: container.scrollLeft + scrollAmount,
                behavior: "smooth",
            });
        } else {
            container.scrollTo({
                left: container.scrollLeft - scrollAmount,
                behavior: "smooth",
            });
        }
    };


    const data = [
        {
            img: "https://picsum.photos/400/250?random=1",
            title: "Taj Fisherman’s Cove Resort & Spa, Chennai",
            location: "Mahabalipuram, India",
            rating: "8.3",
            reviews: "691 reviews",
            tag: "Hotel",
        },
        {
            img: "https://picsum.photos/400/250?random=2",
            title: "Heritage Madurai",
            location: "Madurai, India",
            rating: "8.8",
            reviews: "1294 reviews",
            tag: "Resort",
        },
        {
            img: "https://picsum.photos/400/250?random=3",
            title: "Radisson Blu Resort Temple Bay",
            location: "Mahabalipuram, India",
            rating: "8.6",
            reviews: "940 reviews",
            tag: "Resort",
        },
        {
            img: "https://picsum.photos/400/250?random=4",
            title: "Neemrana's – Tijara Fort Palace",
            location: "Alwar, India",
            rating: "8.5",
            reviews: "332 reviews",
            tag: "Hotel",
        },
        {
            img: "https://picsum.photos/400/250?random=5",
            title: "Club Mahindra Resort",
            location: "Goa, India",
            rating: "9.0",
            reviews: "1032 reviews",
            tag: "Resort",
        },
        {
            img: "https://picsum.photos/400/250?random=6",
            title: "Leela Palace",
            location: "Udaipur, India",
            rating: "9.4",
            reviews: "2101 reviews",
            tag: "Hotel",
        },
        {
            img: "https://picsum.photos/400/250?random=7",
            title: "JW Marriott",
            location: "Mumbai, India",
            rating: "8.9",
            reviews: "1822 reviews",
            tag: "Hotel",
        },
    ];

    return (
        <div className="carousel-wrapper">
{hotelData?.length===0 && !isLoading && <p style={{textAlign:"center",width:"100%"}}>No favorite hotels found.</p>}
{hotelData?.length>0 &&
<>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    <h2>Stay at our top unique Hotels</h2>
                    <p>From castles and villas to boats and igloos, we've got it all</p>
                </div>
                <div ><span className='favourite_showmore' onClick={() => navigate("/hotels")}>+Show More</span></div>
            </div>
{hotelData?.length>4 && (<>
            <button className="arrow left" onClick={() => handleScroll("left")}>
                ‹
            </button>
            <button className="arrow right" onClick={() => handleScroll("right")}>
                ›
            </button>
            </>)}

            <div className="carousel-container" ref={scrollRef}>
                {hotelData.map((item, index) => (
                    <div className="property-card" key={index} onClick={()=>navigate(`/hotel/${item.id}`)}>
                        <div className="image-wrapper">
                            <img src={item.featured_image || hotel_img} alt={item.name} />
                            {/* <span className="heart">♡</span> */}
                        </div>

                        <div className="card-info">
                            <div style={{display:"flex",width:"100%",justifyContent:"space-between"}}>
                                <p className="tag">Hotel</p>
                                <p style={{color:"green",fontWeight:"700"}}>₹{item.rooms[0]?.price_per_night || 0}/night</p>
                                </div>
                            
                            <h3>{item.name}</h3>
                            <p className="location">{item.location}</p>

                            <div className="rating-box">
                                <span className="rating-number">{item.average_rating || 0} </span>
                                <span className="review-text">{item.reviews.length} reviews</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

</>
}


        </div>
    );
};

export default PropertyCarousel;
